(() => {
  const DURATION_MS = 280;
  const EASING = "cubic-bezier(0.4, 0, 0.2, 1)";
  const runningAnimations = new WeakMap();

  const getContent = (item) => item.querySelector("[data-rf-faq-content]");

  const cancelAnimation = (content) => {
    const animation = runningAnimations.get(content);
    if (!animation) return;
    animation.cancel();
    runningAnimations.delete(content);
  };

  const finishOpen = (content) => {
    content.style.height = "auto";
    content.style.opacity = "1";
  };

  const finishClosed = (item, content) => {
    item.open = false;
    content.style.height = "0px";
    content.style.opacity = "0";
  };

  const animateOpen = (item, reduceMotion) => {
    const content = getContent(item);
    if (!content) return;

    cancelAnimation(content);
    item.open = true;

    if (reduceMotion) {
      finishOpen(content);
      return;
    }

    content.style.overflow = "hidden";
    content.style.height = "0px";
    content.style.opacity = "0";

    const endHeight = content.scrollHeight;
    const animation = content.animate(
      [
        { height: "0px", opacity: 0 },
        { height: `${endHeight}px`, opacity: 1 },
      ],
      { duration: DURATION_MS, easing: EASING, fill: "forwards" }
    );

    runningAnimations.set(content, animation);

    animation.onfinish = () => {
      runningAnimations.delete(content);
      finishOpen(content);
    };
    animation.oncancel = () => {
      runningAnimations.delete(content);
    };
  };

  const animateClose = (item, reduceMotion) => {
    const content = getContent(item);
    if (!content || !item.open) return;

    cancelAnimation(content);

    if (reduceMotion) {
      finishClosed(item, content);
      return;
    }

    const startHeight = content.offsetHeight || content.scrollHeight;
    content.style.overflow = "hidden";
    content.style.height = `${startHeight}px`;
    content.style.opacity = "1";

    const animation = content.animate(
      [
        { height: `${startHeight}px`, opacity: 1 },
        { height: "0px", opacity: 0 },
      ],
      { duration: DURATION_MS, easing: EASING, fill: "forwards" }
    );

    runningAnimations.set(content, animation);

    animation.onfinish = () => {
      runningAnimations.delete(content);
      finishClosed(item, content);
    };
    animation.oncancel = () => {
      runningAnimations.delete(content);
    };
  };

  const initFaq = (scope = document) => {
    const sections = scope.querySelectorAll(".rf-faq");
    sections.forEach((section) => {
      if (section.dataset.rfFaqSectionBound === "true") return;
      section.dataset.rfFaqSectionBound = "true";

      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const items = section.querySelectorAll("[data-rf-faq-item]");

      items.forEach((item) => {
        if (item.dataset.rfFaqBound === "true") return;
        item.dataset.rfFaqBound = "true";
        const content = getContent(item);
        if (!content) return;

        if (item.open) {
          content.style.height = "auto";
          content.style.opacity = "1";
        } else {
          content.style.height = "0px";
          content.style.opacity = "0";
        }

        const summary = item.querySelector("summary");
        if (!summary) return;

        summary.addEventListener("click", (event) => {
          event.preventDefault();

          if (item.open) {
            animateClose(item, reduceMotion);
            return;
          }

          items.forEach((other) => {
            if (other !== item && other.open) animateClose(other, reduceMotion);
          });
          animateOpen(item, reduceMotion);
        });
      });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initFaq(document));
  } else {
    initFaq(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initFaq(event.target);
  });
})();
